import React from "react";
import { Box, Progress } from "@chakra-ui/react";

export const ProgressBar = (props) => {
  const percentageComplete =
    props.progressPoints > 0
      ? (props.completedProgressPoints / props.progressPoints) * 100
      : 0;

  return (
    <Box
      pos="fixed"
      zIndex="1"
      top="0"
      left="0"
      right="0"
      width="100%"
      backgroundColor="gray.800"
    >
      <Progress
        colorScheme="green"
        height={props.size === "lg" ? "16px" : "8px"}
        value={percentageComplete}
      />
    </Box>
  );
};
